module.exports = __webpack_public_path__ + "static/img/4.13f8f9b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/1/sp/4.png
// module id = mKMG
// module chunks = 0